import { render, staticRenderFns } from "./SpotCheck.vue?vue&type=template&id=6aae0b36&scoped=true"
import script from "./SpotCheck.vue?vue&type=script&lang=js"
export * from "./SpotCheck.vue?vue&type=script&lang=js"
import style0 from "./SpotCheck.vue?vue&type=style&index=0&id=6aae0b36&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae0b36",
  null
  
)

export default component.exports